import {
  Button,
  Card,
  Grid,
  Typography,
  Fab,
  InputAdornment,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../../components/services/api";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import DowloadBT from "../../Planner/components/dowloadBT";
import SearchData from "../../Planner/components/SearchData";
import { useHistory } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import mime from "mime";
import { saveAs } from "file-saver";
import { DesktopDatePicker, LocalizationProvider, PickersDay } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
export default function RepairList() {
  const history = useHistory();
  const [key, setKey] = useState("");
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toCountry, setToCountry] = useState("all");
  const [location, setLocation] = useState([]);
  const [locationFilter, setLocationFilter] = useState([]);
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState("all");
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [search, setSearch] = useState({
    startDate: "",
    endDate: "",
    Keyword: "",
    ToAction: "",
  });
  const MenuActive = useSelector((state) => state.MenuActive.List);
  /* table data */
  const columns = [
    { field: "RepairStatus", headerName: "RepairStatus", width: 150 },
    { field: "JobOrderNo", headerName: "Job Order No.", width: 200 },
    { field: "ContainerNo", headerName: "Container No.", width: 200 },
    { field: "SaleOrderNo", headerName: "Sale Order No.", width: 200 },
    { field: "ShipperRefNo", headerName: "Shipper Ref No.", width: 200 },
    { field: "BookingNo", headerName: "Booking No.", width: 200 },
    { field: "GateOut", headerName: "Gate OUT", width: 200 },
    { field: "GateIn", headerName: "Gate IN", width: 200 },
    {
      field: "Action",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/ContainerRepair/RepairDetail/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },

    // { field: 1, headerName: "EXPENSE NO.", width: 200 },
    // { field: 2, headerName: "STAFF", width: 200 },
  ];

  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };

  const ContainerRepairList = async () => {
    try {
      const result = await api.get(`api/repair/list?status=1`);
      setData(result.data);
      setDataFilter(result.data);
    } catch (error) {
      console.log("error => ", error);
    }
  };
  const searchContainerRepairList = async () => {
    try {
      const result = await api.get(
        `api/repair/list?status=1${key ? '&keyword=' + key : ''}${dateStart ? '&sdate=' + dateStart :''}${dateEnd ? "&edate=" + dateEnd : ''}${toCountry === "all" ? "" : "&countryId=" + toCountry}${
          toAction === "all" ? "" : "&locationId=" + toAction}`
      );
      setData(result.data);
      setDataFilter(result.data);
    } catch (error) {
      console.log("error => ", error);
    }
  };
  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationFilter(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (toCountry !== "all") {
      const filterLocation = location?.filter(
        (item) => item.CountryId === toCountry
      );
      setLocationFilter(filterLocation);
      setToAction(filterLocation[0]?.LocationId);
    } else {
      setLocationFilter(location);
    }
  }, [toCountry]);

  useEffect(() => {
    ContainerRepairList();
    getLocation();
    getCountry();
  }, []);

  const handleOpenPage = () => {
    history.push("/Truck/AddE.I.R");
  };

  const handleDownload = async () => {
    setLoading(true);
    await api
      .get(
        `api/report/repair-list/download?keyword=${key}&sdate=${dateStart || ''}&edate=${dateEnd || ''}`,
        {
          responseType: "blob",
          timeout: 30000,
        }
      )
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),
        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "Report.xlsx");
        setLoading(false);
      });
  };
  return (
    <>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายการซ่อมตู้คอนเทนเนอร์
        </h6>

        <Grid
          container
          alignItems="center"
          spacing={1}
          sx={{ marginBottom: 3 }}
        >
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Repair List
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Container Repair</Typography>
            <Typography>
              <span>&nbsp;</span> / Repair List
            </Typography>
          </Grid>
        </Grid>

        <Grid
          //   container
          //   sx={{ justifyContent: "end" }}
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <DowloadBT onClick={handleDownload} loading={loading} />
          <FormControl
            size="small"
            sx={{
              width: "350px",
              marginRight: "10px",
            }}
          >
            <InputLabel>Country</InputLabel>
            <Select
              label="Country"
              value={toCountry}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToCountry(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {country?.map((x) => (
                <MenuItem value={x?.CountryId}>{x?.CountryName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "350px",
              marginRight: "10px",
            }}
          >
            <InputLabel>Location</InputLabel>
            <Select
              label="Location"
              value={toAction}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToAction(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {locationFilter?.map((x) => (
                <MenuItem value={x?.LocationId}>{x?.LocationName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Date Start"
              value={dateStart}
              inputFormat="yyyy/MM/dd"
              minDate={new Date("2017-01-01")}
              onChange={(newValue) => {
                setDateStart(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{ width: "350px", marginLeft: "10px" }}
                  {...params}
                />
              )}
            />
            <DesktopDatePicker
              label="Date End"
              value={dateEnd}
              inputFormat="yyyy/MM/dd"
              minDate={new Date(dateStart)}
              onChange={(newValue) => {
                setDateEnd(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{
                    width: "350px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              disableUnderline: true,
            }}
            style={{
              width: "300px",
            }}
            label="Search"
            onChange={(e) => setKey(e.target.value)}
            size="small"
          />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={() => searchContainerRepairList()}
          >
            <SearchIcon />
          </Button>
        </Grid>

        <Box
          sx={{
            height: 600,
            width: "100%",
            marginTop: "10px",
            "& .MuiDataGrid-cell--withRenderer": {
              width: "100%",
              backgroundColor: "#fff",
              position: "sticky",
              right: "0",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.RepairContainerId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
          />
        </Box>
      </Card>
      {/* {MenuActive.find((x) => x.ActionNo === "A052") && (
        <Link to="/ContainerRepair/RepairDetail">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )} */}
    </>
  );
}
